// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__11Vuy","upload":"Small_upload__10Lws","imageWrap":"Small_imageWrap__1mDr2","removeBtn":"Small_removeBtn__J2g15"};